import styled, { css } from 'styled-components'
import { Swiper } from 'swiper/react'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.boxBackground};
`

export const Layout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 4rem;

  @media screen and (min-width: 992px) {
    padding: 2rem;
  }
`

export const Slider = styled(Swiper)`
  max-width: 118rem;
  margin: 0 auto;

  .swiper-pagination {
    position: relative;
    margin-top: 2rem;

    @media screen and (min-width: 992px) {
      margin-top: 0;
    }
  }

  .swiper-pagination-bullet {
    margin: 0 0.3rem !important;
    width: 10%;
    max-width: 5rem;
    height: 0.3rem;
    border-radius: 0;
    background: ${({ theme }) => theme.colors.sliderActionButtonInactive};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.colors.sliderActionButtonActive};
  }

  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
`

const ArrowIcon = styled(ArrowDownIcon)`
  width: 2rem;
  height: 2rem;
`

export const NavigationButton = styled.button`
  display: none;

  @media screen and (min-width: 992px) {
    display: block;
    border: none;
    background: none;
    padding: 2rem;
    color: ${({ theme }) => theme.colors.sliderActionButtonInactive};

    &:hover {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.sliderActionButtonActive};
    }
  }
`

export const ArrowLeftIcon = styled(ArrowIcon)`
  transform: rotate(90deg);
`

export const ArrowRightIcon = styled(ArrowIcon)`
  transform: rotate(-90deg);
`

export const Card = styled.div<{ isSingleSlide: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 3.5rem;

  @media screen and (min-width: 992px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    grid-template-areas: 'Image Text';
    gap: 0 5%;
    padding: 4rem 1%;
    align-items: center;

    ${({ isSingleSlide }) => {
      return (
        isSingleSlide &&
        css`
          padding-left: calc(6rem + 1%);
          padding-right: calc(6rem + 1%);
        `
      )
    }}
  }
`

export const ImageContainer = styled.div`
  width: 100%;

  .safari-lower-than-15 & {
    position: relative;
    padding-top: 100%;
  }
`

export const Image = styled(ResponsiveImage)`
  grid-area: Image;
  object-fit: cover;
  aspect-ratio: 1;
  width: 100%;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
    height: 100%;
  }

  @media screen and (min-width: 992px) {
    max-width: 55rem;
  }
`
export const Text = styled.div`
  grid-area: Text;
  padding: 0 4.5rem;

  @media screen and (min-width: 992px) {
    padding: 0;
  }
`
